import defineComponent from 'flight';

function Toggle() {
    this._toggle = function () {

        this.trigger(document, 'ui:toggle:' + this._context, {
            expand: !this.$node.hasClass('active')
        });

    };

    this._updateState = function (evt, data) {
        if (data.expand) {
            this.$node.addClass('active');
        }
        else {
            this.$node.removeClass('active');
        }
    };

    this.after('initialize', function () {
        this._context = this.$node.data('toggle');
        this.on('click', this._toggle);
        this.on(document, 'ui:toggle:' + this._context, this._updateState);
    });
}

module.exports = defineComponent.component(Toggle);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/toggle.js